import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon } from 'lucide-react';
const BUYERS = ['Carlos de Bogotá acaba de comprar este sistema', 'María de Buenos Aires acaba de comprar este sistema', 'Pedro de Lima acaba de comprar este sistema', 'Ana de Ciudad de México acaba de comprar este sistema', 'Luis de Santiago acaba de comprar este sistema'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyerIndex, setCurrentBuyerIndex] = useState(0);
  useEffect(() => {
    const showPopup = () => {
      setCurrentBuyerIndex(prev => (prev + 1) % BUYERS.length);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show randomly every 15-30 seconds
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.random() * 15000 + 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-385">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      y: 20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs bg-[#1E293B] border border-slate-700 rounded-lg shadow-xl p-3 flex items-center gap-3" data-id="element-386">
          <div className="bg-blue-500/20 p-2 rounded-full flex-shrink-0" data-id="element-387">
            <UserIcon className="w-5 h-5 text-blue-400" data-id="element-388" />
          </div>
          <p className="text-sm text-slate-200 leading-tight" data-id="element-389">
            {BUYERS[currentBuyerIndex]}
          </p>
        </motion.div>}
    </AnimatePresence>;
}